<h2 mat-dialog-title>Choose Image</h2>
<mat-dialog-content>
    <p>Select an option to upload an image.</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button color="primary" (click)="selectOption('camera')" [mat-dialog-close]="'camera'">📷 Camera</button>
    <button mat-button color="accent" (click)="selectOption('gallery')" [mat-dialog-close]="'gallery'">🖼️ Gallery</button>
</mat-dialog-actions>